import { Box, Button, FlexColumn, FlexRowCenter, Text } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import { useStore } from "csi/state/hooks";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent, useEffect } from "react";
import ChannelsList from "./ChannelsList";
import LoadingMSTeams from "./LoadingMSTeams";
import { useMSTeamsStore } from "./MSTeamsStore";

const ConnectToMSTeamsNextTime: FunctionComponent = observer(() => {
	const loc = useLocale();
	const { routerStore } = useStore();
	const {
		connectedChannels,
		fetchConnectChannelsAndTeams,
		navigationToChannelSelection,
		readyToDisplayConnectedChannelsWithTeamNames,
		userIsReadOnly,
	} = useMSTeamsStore();
	const resParams = [loc.type(routerStore.locationNode.$Type)];

	const loading = !readyToDisplayConnectedChannelsWithTeamNames;

	useEffect(() => {
		fetchConnectChannelsAndTeams();
	}, []);

	return (
		<FlexColumn
			justifyContent="flex-end"
			overflow="hidden auto"
			paddingTop={3}
		>
			{loading ?
				<LoadingMSTeams />
				: (
					<>
						<Box px={3}>
							<Text bold res="ConnectedChannelsTitle" />
						</Box>
						<FlexColumn overflow="hidden auto" paddingTop={3}>
							<ChannelsList channels={connectedChannels} />
						</FlexColumn>
						{!userIsReadOnly && (
							<FlexRowCenter
								sx={{
									borderTop: STANDARD_BORDER_STYLE,
									justifyContent: "center",
									padding: "8px 12px",
								}}
							>
								<Button
									design="primary"
									fullWidth
									onClick={navigationToChannelSelection}
									res="ConnectToMSTeamsButton"
									resParams={resParams}
								/>
							</FlexRowCenter>
						)}
					</>
				)}
		</FlexColumn>
	);
});

export default ConnectToMSTeamsNextTime;